import { render } from "./TStatCrit.vue?vue&type=template&id=a5b306f6&scoped=true"
import script from "./TStatCrit.vue?vue&type=script&lang=js"
export * from "./TStatCrit.vue?vue&type=script&lang=js"

import "./TStatCrit.vue?vue&type=style&index=0&id=a5b306f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b306f6"]])

export default __exports__